<div class="section-title">User Access Log for {{asset.asset_name}}</div>

@if (pageLogs === undefined) {
	<div class="loading-status">
		<div class="logo-spin"></div>
		Loading user access logs...
	</div>
}

@if (pageLogs && pageLogs.length === 0) {
	<div class="loading-status">
		No user access logs available
	</div>
}

@if (pageLogs && pageLogs.length > 0) {
	<table class="log compact" [class.loading]="pageLoading">
		<thead>
			<tr>
				<th>Access Time</th>
				<th>User</th>
			</tr>
		</thead>
		@for (log of pageLogs; track log) {
			<tbody>
				<tr>
					<td>{{log.ts | datetime : "offset" : asset.time_offset_hours}}</td>
					<td>{{log.email}}</td>
				</tr>
			</tbody>
		}
	</table>
	<ngb-pagination [collectionSize]="totalLogs" [pageSize]="itemsPerPage" [(page)]="currentPage" (pageChange)="updatePage()" [maxSize]="10" [directionLinks]="true"
		[rotate]="true"></ngb-pagination>
}